import { useEffect, useState } from "react";
import { Monitor } from "lucide-react";

const DESKTOP_MIN = 1024;

function useIsDesktop() {
    const [isDesktop, setIsDesktop] = useState(() =>
        typeof window === "undefined" ? true : window.innerWidth >= DESKTOP_MIN
    );
    useEffect(() => {
        const onResize = () => setIsDesktop(window.innerWidth >= DESKTOP_MIN);
        window.addEventListener("resize", onResize);
        return () => window.removeEventListener("resize", onResize);
    }, []);
    return isDesktop;
}

/**
 * #136 Befund 8: Unter 1024px NICHT mehr redirecten (das verwarf ungespeicherte
 * Dialog-Eingaben), sondern die Admin-Seite gemountet lassen und ein
 * blockierendes Overlay zeigen. Fenster vergrößern => nahtlos weiterarbeiten.
 */
export function RequireDesktop({ children }) {
    const isDesktop = useIsDesktop();
    return (
        <>
            {children}
            {!isDesktop ? (
                <div
                    className="fixed inset-0 z-50 flex items-center justify-center bg-background/95 p-6"
                    data-testid="admin-viewport-overlay"
                >
                    <div className="w-full max-w-md">
                        <AdminMobileHint />
                        <p className="mt-3 text-xs text-muted-foreground">
                            Deine Eingaben bleiben erhalten — vergrößere das Fenster,
                            um genau hier weiterzuarbeiten.
                        </p>
                    </div>
                </div>
            ) : null}
        </>
    );
}

export function AdminMobileHint({ onDismiss }) {
    return (
        <div
            className="rounded-xl border border-border bg-card/60 p-5 text-sm text-muted-foreground"
            data-testid="admin-mobile-hint"
        >
            <div className="mb-2 flex items-center gap-2 text-foreground">
                <Monitor className="h-4 w-4 text-primary" />
                <span className="text-sm font-medium">Admin-Bereich nur auf Desktop</span>
            </div>
            <p>
                Der Leitstand ist für Bildschirme ab 1024 px optimiert. Bitte wechsle
                auf einen Desktop-Browser, um Stammdaten, Reports und Photo Review zu
                nutzen.
            </p>
            {onDismiss ? (
                <button
                    type="button"
                    onClick={onDismiss}
                    className="mt-3 text-xs uppercase tracking-wider text-primary"
                    data-testid="admin-mobile-hint-dismiss"
                >
                    verstanden
                </button>
            ) : null}
        </div>
    );
}
